export default {
  route: {
    systemLog: '系统日志',
    accountType: '账套管理',
    dashboard: "首页",
    documentation: "文档",
    guide: "引导页",
    permission: "权限测试页",
    rolePermission: "角色权限",
    pagePermission: "页面权限",
    directivePermission: "指令权限",
    icons: "图标",
    components: "组件",
    tinymce: "富文本编辑器",
    markdown: "Markdown",
    jsonEditor: "JSON 编辑器",
    avatarUpload: "头像上传",
    dropzone: "Dropzone",
    sticky: "Sticky",
    countTo: "Count To",
    componentMixin: "小组件",
    systemManagement: "系统管理",
    systemConfiguration: "系统配置",
    permissionManagement: "权限管理",
    financialManagement: "财务管理",
    supplierPaymentManagementCW: '付款单管理',
    packingListAuditManagement: "装箱单验审管理",
    saleManagement: "订单发货",
    factoryLoadingPlan: "报关计划",
    warehouseManagement: "仓位管理",
    bookingOrderManagement: "报关合同",
    financialBookingOrderManagement: "报关合同验审管理",
    FactoryInvoiceManagement: "工厂开票管理",
    logisticsBookingOrderManagement: "报关管理",
    customsManagement: "物流管理",
    spaceManagement: "库区/库位/仓位管理",
    deliveryNoteStorageManagement: "进仓单仓位管理",
    shippingManagement: "订舱管理",
    wareHouseEntryGuideDiagram: "进仓单仓位导览图",
    inventoryPlan: "盘库计划",
    inventoryPlanDetail: "盘库计划详情",
    ConfirmInventoryPlan: "确认盘库",
    QueryCustomsPackingHistoryProblem: "主包装异常历史记录",
    inboundManagement: "仓库管理",
    deliveryNoteManagement: "进仓单管理",
    CustomerPackingListManagement: "客人装箱单管理",
    packingListManagement: "装箱单管理",
    deliveryVerification: "交货校验",
    otherExpensesManagement: "其他费用管理",
    hqPackingListDetail: "装箱单详情",
    packageManagement: "包装管理",
    CustomerManagement: "客户列表",
    reportManagement: "报表管理",
    dataConnection: '数据衔接',
    reportDetails: "报表详情",
    appVersion: "版本管理",
    appVersionControl: "APP版本控制",
    customerPackingManagement: "客户装箱单管理",
    uploadFactoryPackingList: "上传箱单",
    mailsManagement: "任务信管理",
    mailsDetail: "任务信",
    deliveryManagement: '交货管理',
    systemMailManagement: "系统任务信配置",
    editHqPackingList: "修改装箱单",
    scanningConfirm: "扫码确认",
    imageManagement: "照片管理",
    outboundManagement: "出库管理",
    henganLoadingPlan: "出库计划(销售)",
    henganLoadingPlanForWarehouse: "出库计划(仓库)",
    henganLoadingPlanDetail: "出库计划详情",
    documentFlow: "单据流",
    askingForQuotation: "销售员询报价",
    askingForQuotationManagement: "询价单管理",
    enquiryQuotationDetails: "询价单详情",
    proformaInvoiceDraft: "生成PI草稿",
    orderProductLibrary: "下单库管理",
    quotationProductLibrary: "报价库管理",
    salesOrderManagement: "销售订单管理",
    salesOrder: "PI管理",
    PIDetails: "PI详情",
    revisePI: "修改PI",
    overOrOweList: "超欠发列表",
    piDeliveryTracking: "PI交货期跟踪",
    abnormalDeliveryHandling: "异常交货处理",
    customerInventoryManagement: "客人库存管理",
    orderManagement: "下单管理",
    orderDetails: "订单详情",
    PIPaymentManagement: "PI收款管理",
    quotationAudit: "报价单管理",
    quotationDetails: "报价单详情",
    editQuotation: "编辑报价单",
    askingForQuotationDetail: "询价单详情",
    quotationManagement: "报价管理",
    markManagement: "唛头管理",
    packageInfoManagement: "客人资料管理",
    customerPackageManagement: "客人包装管理",
    customerBrandPackageList: "客人品牌包装",
    piPackageManagement: "PI包装",
    piPackageDetail: "包装PI详情",
    noPackageDetail: "无包装PI详情",
    packingMaterialManagement: "装箱资料管理",
    otherInfoManagement: "额外信息管理",
    shellPackageInfoManagement: "壳体包装管理",
    brandManagement:"品牌管理",
    transship: "驳货费用登记",
    requestQuote: '询价下单',
    customerIvManagement: "IV收款分配",
    customerIvManagementInfo: "IV管理",
    ivSettleAccount: 'IV清账',
    settleAccountManagement: '客人收款清账',
    customerCollectionManagement: '客人收款管理',
    deliveryVoucher: "出库单",
    templateManagement: "模版管理",
    factoryDeliveryNoteTemplate: "子进仓单模板",
    warehouseInChargeTemplate: "进仓费模板",
    containerTypeConfiguration: "柜型配置",
    roleManagement: "角色管理",
    jobPositionManagement: "岗位管理",
    informationMaintenance: "信息维护",
    declarationElement: "申报要素",
    financial: "调整汇率",
    supplierManagement: "供应商管理",
    informationCardManagement: "名片信息管理",
    userManagement: "用户管理",
    basicConfiguration: "基础配置",
    backToTop: "返回顶部",
    draggableDialog: "可拖拽对话框",
    draggableKanban: "可拖拽看板",
    draggableList: "可拖拽列表",
    draggableSelect: "可拖拽选择",
    charts: "图表",
    barChart: "柱状图表",
    lineChart: "折线图",
    mixedChart: "混合图表",
    example: "综合实例",
    nested: "路由嵌套",
    menu1: "菜单 1",
    "menu1-1": "菜单 1-1",
    "menu1-2": "菜单 1-2",
    "menu1-2-1": "菜单 1-2-1",
    "menu1-2-2": "菜单 1-2-2",
    "menu1-3": "菜单 1-3",
    menu2: "菜单 2",
    table: "表格",
    dynamicTable: "动态表格",
    draggableTable: "可拖拽表格",
    inlineEditTable: "表格内编辑",
    complexTable: "综合表格",
    tab: "分栏",
    form: "表单",
    createArticle: "创建文章",
    editArticle: "编辑文章",
    articleList: "文章列表",
    errorPages: "错误页面",
    page401: "401",
    page404: "404",
    errorLog: "错误日志",
    excel: "Excel",
    exportExcel: "导出 Excel",
    selectExcel: "导出 已选择项",
    mergeHeader: "导出 多级表头",
    uploadExcel: "上传 Excel",
    zip: "Zip",
    pdf: "PDF",
    exportZip: "导出 Zip",
    theme: "换肤",
    clipboard: "粘贴板",
    i18n: "国际化",
    externalLink: "外链",
    profile: "个人中心",
    productBusinessManagement: "产品管理",
    productCategoryManagement: "客人华强号码管理",
    hqSnManagement: "华强品名及号码管理",
    hqProductNumberManagement: "华强编号管理",
    hqProductNumberUnitList: "华强编号单元",
    productSystemManagement: "产品系统管理",
    productNumberManagement: "编号管理",
    productNumberTypeManagement: "号码类型优先级管理",
    hqTransactionNumberManagement: "华强交易号码",
    productNumberUnitList: "编号单元",
    enquiryFormManagement: "询价单管理",
    formUploadTool: "表单上传工具",
    taskManagement: "表单任务中心",
    customerInfoManagement: "客人信息管理",
    purchaseOrderManagement: "采购订单管理",
    supplierOrderManagement: "供应商订单管理",
    viewAllPurchaseOrders: "订单管理",
    poDeliveryTracking: "约定交期跟踪",
    viewAllPurchaseOrdersCW: '采购订单核销',
    invoiceBookingOrder: "报关开票管理",
    invoiceBookingOrderDetail: "报关开票详情",
    invoice: "发票管理",
    viewAllClaims: "查看所有索赔",
    managePurchaseOrders: "管理采购订单",
    paymentTermsMaintenance: "付款信息管理",
    purchaseOrderDetails: "采购订单详情",
    creditNoteManagement: "CreditNote管理",
    claimManagement: "索赔单管理",
    claimDetails: "索赔单详情",
    // financialReconciliationManagement: "财务清账管理",
    supplierPaymentManagement: "查看付款单",
    createPaymentOrder: "新建付款单",
    paymentOrderDetails: "查看付款单详情",
    collectionManagement: "收汇单管理",
    closingPositionManagement: "平仓管理",
    closingPositionManagementInfo: "平仓单管理",
    reviewClosingOrders: "审核平仓单",
    guestsInStock: "客人在库",
    closingPositionDetail: "平仓单详情",

    setAccounts: '帐套设置'
  },
  navbar: {
    logOut: "退出登录",
    dashboard: "首页",
    github: "项目地址",
    theme: "换肤",
    size: "布局大小",
    profile: "个人中心",
  },
  login: {
    title: "系统登录",
    logIn: "登录",
    username: "账号",
    password: "密码",
    any: "随便填",
  },
  documentation: {
    documentation: "文档",
    github: "Github 地址",
  },
  userManagement: {
    name: "姓名",
    phone: "手机号",
    staffCode: "员工编号",
    roleName: "角色",
    jobPosition: "岗位",
    status: "状态",
    englishName: '英文名称'
  },
  permission: {
    createRole: "新增角色",
    editPermission: "编辑权限",
    roles: "你的权限",
    switchRoles: "切换权限",
    tips: "在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。",
    delete: "删除",
    confirm: "确定",
    cancel: "取消",
  },
  guide: {
    description:
      "引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于",
    button: "打开引导",
  },
  components: {
    documentation: "文档",
    tinymceTips:
      "富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见",
    stickyTips: "当页面滚动到预设的位置会吸附在顶部",
    backToTopTips1: "页面滚动到指定位置会在右下角出现返回顶部按钮",
    backToTopTips2:
      "可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素",
    imageUploadTips:
      "由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。",
    changeLanguageTips: "切换语言成功",
  },
  table: {
    name: "名称",
    createDate: "创建日期",
    dynamicTips1: "固定表头, 按照表头顺序排序",
    dynamicTips2: "不固定表头, 按照点击顺序排序",
    dragTips1: "默认顺序",
    dragTips2: "拖拽后顺序",
    title: "标题",
    importance: "重要性",
    type: "类型",
    remark: "点评",
    search: "搜索",
    add: "新增",
    export: "导出",
    reviewer: "审核人",
    id: "序号",
    date: "时间",
    author: "作者",
    readings: "阅读数",
    status: "状态",
    actions: "操作",
    edit: "编辑",
    publish: "发布",
    draft: "草稿",
    delete: "删除",
    cancel: "取 消",
    confirm: "确 定",
    disable: "禁用",
    documentFlow: "单据流"
  },
  example: {
    warning:
      "创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见",
  },
  errorLog: {
    tips: "请点击右上角bug小图标",
    description:
      "现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。",
    documentation: "文档介绍",
  },
  excel: {
    export: "导出",
    selectedExport: "导出已选择项",
    placeholder: "请输入文件名(默认excel-list)",
  },
  zip: {
    export: "导出",
    placeholder: "请输入文件名(默认file)",
  },
  pdf: {
    tips: "这里使用 window.print() 来实现下载pdf的功能",
  },
  theme: {
    change: "换肤",
    documentation: "换肤文档",
    tips: "Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。",
  },
  tagsView: {
    refresh: "刷新",
    close: "关闭",
    closeOthers: "关闭其它",
    closeAll: "关闭所有",
  },
  settings: {
    title: "系统布局配置",
    theme: "主题色",
    showTagsView: "显示 Tags-View",
    showSidebarLogo: "显示侧边栏 Logo",
    fixedHeader: "固定 Header",
    sidebarTextTheme: "侧边栏文字主题色",
  },
  spaceManagement: {
    rowName: "库区名称",
    columnName: "库位名称",
    layerName: "仓位名称",
    isMultiple: "是否小件库区",
  },
};
